"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.never = void 0;

var _NeverObservable = require("./NeverObservable");

var never = _NeverObservable.NeverObservable.create;
exports.never = never;